<template>
  <div class="img-carousel-container">
    <el-carousel
      ref="carousel"
      :autoplay="false"
      arrow="always"
      :initial-index="initialIndex"
      indicator-position="none"
      @change="changeIndex"
    >
      <el-carousel-item
        v-for="(item, index) in imgList"
        :key="index"
      >
        <el-image
          :src="item.b_uri"
          fit="cover"
          @click="toBigImage(index)"
        >
          <div
            slot="error"
            class="image-slot"
          >
            <img :src="imgError">
            <h6>图片加载中......</h6>
          </div>
        </el-image>
        <h3 class="indicator">
          {{ index + 1 }}/{{ imgList.length }}
        </h3>
      </el-carousel-item>
    </el-carousel>
    <h4 v-if="currentName">
      图片名称：{{ currentName }}
    </h4>
    <div class="thumb-list">
      <el-image
        v-for="(item, index) in imgList"
        :key="index"
        fit="cover"
        @click="changeActiveIndex(index)"
        :class="{ active: index === currentIndex }"
        :src="item.s_uri"
      >
        <div
          slot="error"
          class="image-slot"
        >
          <img :src="imgError">
          <h6>图片加载中......</h6>
        </div>
      </el-image>
    </div>
    <ImageViewer
      :img-list="imgArrView"
      ref="imageArrViewer"
    />
  </div>
</template>

<script>
import ImageViewer from '@components/detail/ImageViewer.vue'
export default {
  name: 'ImgCarousel',
  props: {
    imgList: {
      type: Array,
      default: () => []
    },
    initialIndex: {
      type: Number,
      default: 0
    }
  },
  components: {
    ImageViewer
  },
  data() {
    return {
      currentIndex: this.initialIndex,
      imgError: require('@assets/imgs/jlxk/image-error.png')
    }
  },
  computed: {
    currentName() {
      return (
        this.imgList.length !== 0 &&
        this.imgList[this.currentIndex] &&
        this.imgList[this.currentIndex].name
      )
    },
    imgArrView() {
      if (this.imgList.length === 0) return []
      return this.imgList.map(item => item.b_uri) || []
    }
  },
  created() {},
  mounted() {},
  methods: {
    changeIndex(index) {
      this.currentIndex = index
      this.$emit('updateIndex', index)
    },
    toBigImage(index) {
      this.$refs.imageArrViewer.showViewer = true
      this.$nextTick(() => {
        this.$refs.imageArrViewer.$refs.imageViewer.index = index
      })
    },
    // 缩略图更改当前图
    changeActiveIndex(index) {
      this.$refs.carousel.setActiveItem(index)
    }
  }
}
</script>

<style lang="scss" scoped>
@font-face {
  font-family: element-icons;
  src: url("~@assets/fonts/element-icons.woff") format("woff"),
    url("~@assets/fonts/element-icons.ttf") format("truetype");
  font-weight: 400;
  font-display: "auto";
  font-style: normal;
}
/deep/ .el-icon-arrow-right:before {
  content: "\e6e0";
  font-size: 30px;
  font-weight: 700;
}
/deep/ .el-icon-arrow-left:before {
  content: "\e6de";
  font-size: 30px;
  font-weight: 700;
}
.img-carousel-container {
  /deep/ .el-carousel {
    &__container {
      width: 590px;
      height: 300px;
      margin: 0 auto;
      text-align: center;
    }
    &__arrow {
      width: 38px;
      height: 66px;
      background: rgba(0, 0, 0, 0.3);
      box-shadow: 0px 5px 7px 1px rgba(5, 29, 64, 0.21);
      border-radius: 0;
      &--left {
        left: -15px;
      }
      &--right {
        right: -15px;
      }
    }
    .el-image {
      height: 100%;
      img {
        width: 100%;
        height: 100%;
        cursor: zoom-in;
      }
    }
    .image-slot {
      img {
        width: 150px;
        height: 90px;
      }
    }
    .indicator {
      position: absolute;
      right: 20px;
      bottom: 5px;
      font-size: 12px;
      color: #000;
      line-height: 22px;
      z-index: 10;
    }
  }
  h4 {
    margin: 15px 0 0 10px;
    color: #333;
    font-size: 13px;
    line-height: 22px;
    @extend .ellipsis;
    text-align: left;
  }
  .thumb-list {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
    /deep/ .el-image {
      width: 150px;
      height: 105px;
      padding: 7px;
      border: 1px solid #fff;
      &.active {
        border-color: #4497ec;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
    /deep/.image-slot{
      img{
        width:100px;
        height:60px;
      }
    }
  }
  /deep/.image-slot {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #edf0f7;
    border-radius: 5px;
    height: 100%;
    img {
      margin-top: 0;
    }
    h6 {
      font-size: 13px;
    }
  }
}
</style>
